module.exports = __webpack_public_path__ + "static/PatKT-07-0e56b584448e1556588be640a35d71af.jpg";